


















































































import { Component, Prop, Vue } from "vue-property-decorator";
import {
  RedCapital,
  SelectedCountry,
  TitleTemplatePublic
} from "@/configuration";

@Component({
  metaInfo() {
    return {
      title: "Blog",
      titleTemplate: TitleTemplatePublic,
      htmlAttrs: {
        // @ts-ignore
        lang: RedCapital[SelectedCountry].Lang
      }
    };
  },
  data() {
    return {
      showComments: false,
      title: "¿Estoy ganando dinero con mi empresa?",
      subtitle: "Aprende como calcular ganancias y otros",
      image: "https://via.placeholder.com/800x400",
      thumbnail: "https://via.placeholder.com/350x350",
      author: "Adriana Bone",
      date: "Abril 2019",
      tags: ["ganando", "inversion", "redcapital"],
      content:
        "Para mantener el negocio en pie, lo más importante es saber si estoy ganando o perdiendo plata. Aunque esto parece muy obvio, no todos los empresarios saben realmente cuáles son las ganancias (o pérdidas) de una empresa. Las ganancias son las ventas o la facturación de un período, menos los egresos del mismo período. Ventas (productos o servicios facturados) – egresos=gananciasLos egresos son los costos + los gastos. Los costos son todos los egresos que están asociados a la generación del producto o servicio. Por ejemplo, si tengo una fabrica de tortas, los costos serían, los huevos, harina, etc (costos variables) y la contratación de un empleado (costo fijo). Los gastos son lo que rodea la generación del producto, por ejemplo, sería el arriendo del local donde se venden las tortas, la contratación de un contador, etc.<br><br><b>¿Cómo calcular mis costos?</b><br>Los costos son todos los egresos que están asociado a la generación del producto o servicio. Por ejemplo, si tengo una fábrica de tortas, los costos serían, los huevos, harina, etc (costos variables) y la contratación de un empleado (costo fijo). ¿Cómo calculo cuánto vale producir mi producto?Es muy importante definir cuánto me cuesta producir determinado producto. Sólo de este modo podré definir el precio correctamente, sin perder dinero. Para lograr esto, hay que entender la “receta” de cada producto… qué ingredientes ocupo para producirlo. Por ejemplo, para la fabricación de una torta, la receta serían los ingredientes, pero a esto hay que sumarle: -El tiempo del empleado que trabajo en esto (mano de obra asociada a la generación del producto). Si es el mismo dueño el que trabajó fabricando el producto, es muy importante que él se asigne un salario, para que se pueda sacar el costo real de la producción de la torta. Esto también permitirá calcular el costo de oportunidad, que significa lo que pierde o gana el empresario por estar ahí y dejar de trabajar en, por ejemplo, otra empresa. <br><br><b>¿Cómo sé si le está yendo bien a mi negocio?</b><br>Para esto debo fijarme en lo siguiente:<ul><li>Tracción de ventas. Si mis ventas están aumentando, se mantienen o están cayendo.</li><li>Mis ganancias. Que estas vayan aumentando, pero sin aumentar los precios de los productos que vendo, sino que optimizando los recursos de la empresa. Por ejemplo, que el local que arriendo para hacer las tortas, me sirva también para hacer galletas. Eso hace que pueda comprar insumos más baratos y que además el local me sirve para abrir el rubro.</li><li>Mi caja debiera ir aumentando.</li><li>Deudas. Que la empresa no se esté endeudando para cubrir pérdidas. Si estoy creciendo las deudas deben ser para cubrir capital de trabajo o activos. Por ejemplo, para comprar un horno, que me permitirá producir más tortas. Para crecer, muchas veces hay que endeudarse.</li></ul>",
      comments: [
        {
          text:
            "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum tempor.",
          name: "Alfred",
          mail: "alfred@redcapital.cl"
        },
        {
          text:
            "Nulla hendrerit urna eu tempor tincidunt. Class aptent taciti sociosqu.",
          name: "John",
          mail: "john@redcapital.cl"
        },
        {
          text:
            "Donec id sodales massa. Etiam in tincidunt justo. Phasellus euismod.",
          name: "Will",
          mail: "will@redcapital.cl"
        },
        {
          text:
            "Integer leo odio, fringilla id enim nec, viverra vehicula velit.",
          name: "Thomas",
          mail: "thomas@redcapital.cl"
        }
      ],
      valid: true,
      mail: "",
      name: ""
    };
  }
})
export default class Blog extends Vue {}
